import { FacturaSegmento } from "./types";

export const DENOMINACIONES = [100000, 50000, 20000, 10000, 5000, 2000, 1000, 500, 100];

export const DETALLE_TARJETA_PROVEEDORES = ["DINELCO", "BANCARD", "UPAY", "PAGOPAR"];

export const FORMAS_EXCLUIDAS = new Set([
  "CONTINENTAL CTA CTE",
  "CUPON PEDIDOYA",
  "DEBITO",
  "DIF.DE CAMBIO(+)",
  "DIF.DE CAMBIO(-)",
  "RET. LEY 2057",
  "9. VISA CREDITO",
  "15.DESCUENTO DEL PERSONAL",
]);

export const FACTURA_CAMPOS: { etiqueta: string; campo: keyof FacturaSegmento; longitud: number }[] = [
  { etiqueta: "Establecimiento", campo: "establecimiento", longitud: 3 },
  { etiqueta: "Punto de expedición", campo: "punto", longitud: 3 },
  { etiqueta: "Número", campo: "numero", longitud: 7 },
];

export const TOTAL_DIGITOS_FACTURA = FACTURA_CAMPOS.reduce((acc, campo) => acc + campo.longitud, 0);

export interface WizardStep {
  id: string;
  label: string;
  navLabel: string;
  navDescription: string;
  ayuda?: string;
}

export const WIZARD_STEPS: WizardStep[] = [
  {
    id: "seleccion",
    label: "Seleccionar caja",
    navLabel: "Seleccion",
    navDescription: "Caja y sucursal",
    ayuda: "Eligí la sucursal y la caja con la que vas a trabajar. Acá traemos los datos del día anterior para que puedas conciliar.",
  },
  {
    id: "facturas-rango",
    label: "Declarar números",
    navLabel: "Rangos",
    navDescription: "Números fiscales",
    ayuda: "Ingresá el rango de facturas emitidas (desde/hasta) para declarar los números fiscales del turno.",
  },
  {
    id: "facturas-anuladas",
    label: "Facturas anuladas",
    navLabel: "Anuladas",
    navDescription: "Registra bajas",
    ayuda: "Registrá las facturas anuladas del turno y dejá constancia del motivo/soporte.",
  },
  {
    id: "fondo",
    label: "Fondo para sencillo",
    navLabel: "Fondo",
    navDescription: "Efectivo detallado",
    ayuda: "Contá el efectivo (por denominaciones) para justificar el fondo de sencillo que mantiene la caja.",
  },
  {
    id: "gastos",
    label: "Gastos",
    navLabel: "Gastos",
    navDescription: "Comprobantes",
    ayuda: "Cargá los gastos asociados al turno (vales, reposiciones, comprobantes).",
  },
  {
    id: "pagos",
    label: "Formas de pago",
    navLabel: "Pagos",
    navDescription: "Medios cobrados",
    ayuda: "Declarar los importes por forma de pago (tarjetas, transferencias, etc.) para comparar con Tesorería.",
  },
  {
    id: "boletas",
    label: "Boletas",
    navLabel: "Boletas",
    navDescription: "Depósitos",
    ayuda: "Ingresá las boletas de depósito relacionadas al turno y enlazá las cuentas bancarias.",
  },
  {
    id: "confirmacion",
    label: "Confirmar e imprimir",
    navLabel: "Confirmar",
    navDescription: "Resumen y PDF",
    ayuda: "Revisá el resumen final, generá el PDF de la rendición y confirmá para enviarlo a Tesorería.",
  },
];
